module.exports = __webpack_public_path__ + "img/logs-black.b3031dfa.svg";